var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.objectURL)?_c('v-img',{attrs:{"contain":"","src":_vm.objectURL,"alt":_vm.altText,"max-width":"100vw"}}):_c('v-progress-circular',{attrs:{"indeterminate":""}})}
var staticRenderFns = []

export { render, staticRenderFns }